var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{ref:"btnGroup"},[_c('v-circle',{ref:"btn",attrs:{"config":_vm.btnConfig}}),_c('v-text',{ref:"icon",attrs:{"config":_vm.iconConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }